"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _useListBox = _interopRequireDefault(require("../useListBox"));

var _invokeOnChange = _interopRequireDefault(require("../helpers/invokeOnChange"));

var _options = require("../components/Options/helpers/options");

var handleImperative = function handleImperative(_ref) {
  var state = _ref.state,
      dispatch = _ref.dispatch,
      onChangeContext = _ref.onChangeContext;
  return function () {
    return {
      clear: function clear() {
        var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        dispatch({
          type: _useListBox["default"].types.clear,
          payload: {
            isOpen: isOpen,
            onChangeFn: (0, _invokeOnChange["default"])(onChangeContext, "list-box:imperative:clear")
          }
        });
      },
      reset: function reset() {
        dispatch({
          type: _useListBox["default"].types.reset,
          payload: {
            onChangeFn: (0, _invokeOnChange["default"])(onChangeContext, "list-box:imperative:reset")
          }
        });
      },
      focus: function focus() {
        state.refTrigger.current.focus();
      },
      setFocusOptionByIndex: function setFocusOptionByIndex(index) {
        var optionElement = state.refListBox.current.childNodes[index];
        optionElement.focus();
        dispatch({
          type: _useListBox["default"].types.setActiveOption,
          payload: {
            activeOptionIndex: index
          }
        });
      },
      toggleSelectedOption: function toggleSelectedOption(index) {
        (0, _options.toggleOption)({
          index: index,
          isMulti: state.isMulti,
          dispatch: dispatch,
          onChangeContext: onChangeContext
        });
      },
      selected: state.isMulti ? state.selectedOptions : state.selectedOptions[0],
      options: state.options,
      close: function close() {
        dispatch({
          type: _useListBox["default"].types.closePopover
        });
      }
    };
  };
};

var _default = handleImperative;
exports["default"] = _default;
//# sourceMappingURL=imperative.js.map